<template>

    <v-expansion-panel expand :class="panelClass">
      <v-expansion-panel-content>
        <div slot="header"><slot name="title"></slot></div>
        <v-card>
          <v-card-text :class="textClass">
            <slot></slot>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

</template>

<script>

export default {
  components: {

  },
  data () {
    return {
      panelClass: 'mb-1',
      textClass: 'grey lighten-3'
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
